import { render, staticRenderFns } from "./TicketSettingsDeleteDialog.vue?vue&type=template&id=bc976f3a&"
import script from "./TicketSettingsDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./TicketSettingsDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports